import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import {
  grey2,
  grey5,
  grey6,
  grey10,
} from 'approot/shared/styles/colours.style';
import { spacing8 } from 'approot/shared/styles/spacing.style';
import { fontSize14, fontSize16 } from 'approot/shared/styles/typography.style';
import {
  standardFocusState,
  standardInsetBoxShadow,
} from 'approot/shared/styles/borders.style';

export const Pagination = styled.nav`
  display: flex;
  justify-content: center;
`;

export const PaginationButtons = styled.ul`
  margin: 0;
  padding: 0;
  align-items: center;
  display: flex;
  justify-content: center;

  li {
    list-style: none;
  }
`;

type PaginationButtonProps = {
  $isActive?: boolean;
};
export const PaginationButton = styled.button<PaginationButtonProps>`
  background: none;
  border: 1px solid ${grey5};
  border-radius: ${rem(40)};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: ${rem(fontSize14)};
  min-width: ${rem(40)};
  min-height: ${rem(40)};

  ${standardFocusState}

  &:hover {
    background-color: ${grey2};
    cursor: pointer;
  }

  &:disabled,
  &:disabled:active,
  &:disabled:hover {
    background-color: transparent;
    border-color: ${grey5};
    box-shadow: none;
    cursor: not-allowed;
    color: ${grey6};

    svg {
      stroke: ${grey5};
    }
  }

  &:active:focus {
    ${standardInsetBoxShadow}
  }
`;

export const PaginationNext = styled(PaginationButton)`
  border: none;

  svg {
    transform: rotate(-90deg);
  }
`;

export const PaginationPrev = styled(PaginationButton)`
  border: none;

  svg {
    transform: rotate(90deg);
  }
`;

type PaginationTotalProps = {
  $isSmall?: boolean;
};

export const PaginationTotal = styled.li<PaginationTotalProps>`
  ${({ $isSmall }) =>
    $isSmall
      ? `font-size: ${rem(fontSize14)};`
      : `font-size: ${rem(fontSize16)}`}

  color: ${grey10};
  margin: 0 ${rem(spacing8)};
`;
